export const selectIssueType = state => state.support?.issueType;
export const selectIssueDescription = state => state.support?.description || "";
export const selectIssueAttachments = state => state.support?.attachments || [];
export const selectSendEmailLoading = state => state.support?.loading || false;
export const selectSentStatus = state => state.support?.sentStatus || false;
